import Vue from 'vue'
// import tracer from '@mc/tracer/platform/web'
import tracer from '@mc/tracer/dist/tracer.web.js'
import baseParam from './baseParam'
import projectConfig from './projectConfig'
import store from '@/store'

const sourceFromMap = {
  1: '自营',
  2: 'pop',
  3: '美农源头',
  4: '美农肉禽',
  5: '家家源',
  10: '美家优享',
  11: 'KA分销',
  12: '美菜到家',
  13: '县域',
  14: '大客户',
  15: '代采'
}

Vue.prototype.$tracer = {
  page: function (path) {
    const { passportPhone, supplierNo, id, classes, sourceFrom } = store.getters.loginSupplier
    tracer.page(path, {
      sweb_source_from_str: sourceFromMap[sourceFrom] || '无',
      sweb_supplier_no: supplierNo,
      sweb_business_classes: classes || '无',
      sweb_supplier_id: id + '' || '无',
      sweb_passport_phone: passportPhone,
      sweb_page_source: '无'
    })
  },
  click: function (spm) {
    const { passportPhone, supplierNo, id, classes, sourceFrom } = store.getters.loginSupplier
    tracer.click(spm, {
      sweb_source_from_str: sourceFromMap[sourceFrom] || '无',
      sweb_supplier_no: supplierNo,
      sweb_business_classes: classes || '无',
      sweb_supplier_id: id + '' || '无',
      sweb_passport_phone: passportPhone,
      sweb_page_source: '无'
    })
  },
  updateParam: function(param) {
    tracer.updateParam(param)
  }

}
tracer.init(projectConfig, baseParam)



// WEBPACK FOOTER //
// ./src/tracer/index.js